/* global videojs */

import { changeCam } from "../handlers/camera-tracks-handlers";
import OverlayGridMenu from "../components/overlay-grid-menu";

function createThumbnailElement (src) {
  const el = document.createElement('img');
  el.src   = src;
  el.className = 'vjs-camera-thumbnail';
  return el;
}

class SwitchCameraButton extends videojs.getComponent('Button') {

  constructor (player, options) {
    super(player, options);

    this.controlText('Switch between cameras');
    this.addClass('vjs-switch-camera-button vjs-menu-button');

    this.updateMenuItems();              // crea menú inicial

    /* --- abrir menú con click / tap --- */
    this.el().addEventListener('click', () => this.toggleCameraMenu());

    let lastTouch = 0;
    this.el().addEventListener('touchend', e => {
      const now = Date.now();
      if (now - lastTouch > 50) {
        lastTouch = now;
        this.toggleCameraMenu();
        e.preventDefault();
      }
    });
  }

  /* ---------- overlay con miniaturas ---------- */
  toggleCameraMenu () { this.openCameraOverlay(); }

  openCameraOverlay () {
    const itemsForGrid = this.cameraItems.map((item, idx) => {
      const img   = item.el().querySelector('img')?.src;
      const label = item.el().textContent.trim();
      return {
        label,
        thumb: img,
        selected: idx === this.selectedCameraIndex,
        onSelect: () => {
          changeCam(idx, this.cameraItems);
          localStorage.setItem('selectedCameraIndex', idx);
          this.setCameraSelection(idx);
        }
      };
    });
    OverlayGridMenu(this.player_, itemsForGrid, { maxTile: '15rem' });
  }

  /* ---------- llena/actualiza la lista ---------- */
  updateMenuItems () {
    let cameraTracks = [];

    if (window.isDashSource) {
      /* DASH / hls.js */
      cameraTracks = window.dashMediaPlayer?.getTracksFor?.('video') || [];
    } else if (window.isWebRTC) {                               // WEBRTC-★
      /* En WebRTC no hay playlist ni tracks reales;
         usamos la longitud de camNames como referencia */
      cameraTracks = (window.camNames || []).map((_, i) => i);
    } else {
      /* Playlist (m3u8 individuales) */
      cameraTracks = this.player_.playlist();
    }

    const firstTime  = !this.hasUpdatedItems;
    this.hasUpdatedItems = true;

    if (firstTime) {
      this.selectedCameraIndex = 0;
    } else {
      const stored = localStorage.getItem('selectedCameraIndex');
      this.selectedCameraIndex = stored !== null ? parseInt(stored, 10) : 0;
    }

    this.cameraItems = this.createItems(cameraTracks);

    if (this.cameraItems.length <= 1) this.hide();
    else {
      this.show();
      this.setCameraSelection(this.selectedCameraIndex);
    }
  }

  /* ---------- marca item seleccionado ---------- */
  setCameraSelection (idx) {
    this.selectedCameraIndex = idx;
    (this.cameraItems || []).forEach((item, i) => {
      const sel = i === idx;
      item.el().classList.toggle('vjs-selected', sel);
      item.el().setAttribute('aria-checked', sel);
    });
  }

  /* ---------- fabrica los MenuItem ---------- */
  createItems (cameraTracks) {
    const MenuItem = videojs.getComponent('MenuItem');
    const items    = [];

    const len = cameraTracks.length;
    for (let i = 0; i < len; i++) {

      let thumb = "https://dzsyhtfpcz9op.cloudfront.net/staticResources/logo-cam01.jpg";
      if (window.camImages?.length > i) thumb = window.camImages[i];

      const camName = window.camNames?.[i] || `Camera ${i + 1}`;
      const thumbEl = createThumbnailElement(thumb);

      const item = new MenuItem(this.player_, { label: '' });
      if (thumbEl) item.el().appendChild(thumbEl);
      item.el().appendChild(document.createTextNode(camName));

      const select = () => {
        changeCam(i, items);
        localStorage.setItem('selectedCameraIndex', i);
        this.setCameraSelection(i);
      };

      item.on('click', select);
      /* gestos táctiles */
      let scrolling = false;
      item.on('touchstart', e => { e.preventDefault(); scrolling = false; });
      item.on('touchmove',  () => scrolling = true);
      item.on('touchend',   () => { if (!scrolling) select(); });

      items.push(item);
    }
    return items;
  }
}

/* Oculta el viejo icono genérico de cámaras */
const css = document.createElement('style');
css.innerHTML = '.vjs-camera-button{display:none!important}';
document.head.appendChild(css);

videojs.registerComponent('SwitchCameraButton', SwitchCameraButton);
export default SwitchCameraButton;